import React, { Component } from "react";
import PropTypes from "prop-types";
import { withRouter } from "react-router-dom";
import AccountContainer from "./AccountContainer";

class AccountUrlResolver extends Component {
  constructor(props) {
    super(props);
    this.resolveSectionRoute = this.resolveSectionRoute.bind(this);
  }

  resolveSectionRoute(props) {
    const { accountId } = props.match.params;

    const section = props.location.pathname
      .split("/")
      .slice(-1)
      .pop();
    let tabIndex = this.props.labels.indexOf(section);

    if (tabIndex < 0) {
      tabIndex = props.tabIndex;
      props.history.push(
        `/accounts/${accountId}/${this.props.labels[tabIndex]}`
      );
    }
    this.props.persistTab(tabIndex);
  }

  componentDidMount() {
    this.resolveSectionRoute(this.props);
    this.props.fetchAccount(this.props.match.params.accountId);
  }

  componentWillReceiveProps(nextProps) {
    const { accountId } = nextProps.match.params;
    if (this.props.match.params.accountId !== accountId) {
      nextProps.fetchAccount(accountId);
    }
    this.resolveSectionRoute(nextProps);
  }

  render() {
    return <AccountContainer account={this.props.account} />;
  }
}

AccountUrlResolver.propTypes = {
  tabIndex: PropTypes.number.isRequired,
  labels: PropTypes.array.isRequired,
  persistTab: PropTypes.func.isRequired,
  fetchAccount: PropTypes.func.isRequired,
  account: PropTypes.object
};

export { AccountUrlResolver };

export default withRouter(AccountUrlResolver);



// WEBPACK FOOTER //
// ./src/AccountUrlResolver.js